import TokenService from '@/core/services/token.service';
import { ProfileInterface, UserPermissions } from '@/shared/interfaces/profile.interface';

export interface State {
    token: string;
    status: string;
    user: {
        email: string,
        password: string,
    };
    profile: ProfileInterface;
    userPermissions: UserPermissions
}

export const state: State = {
    // Vía TokenService para que un token caducado no deje `isAuthenticated`
    // en true y permita entrar en rutas privadas que después fallarán.
    token: TokenService.get() || '',
    status: '',
    user: {
        email: '',
        password: '',
    },
    profile: {},
    userPermissions: {}
};
